import { useState } from "react";
import "./App.css";
import LandingPage from "./components/LandingPage";
import CardCarousel from "./components/CardCarousel";
import PhotoGallery from "./components/PhotoGallery";
import ValPlans from "./components/ValPlans";
import CountdownTimer from "./components/CountdownTimer";
import FloatingHearts from "./components/FloatingHearts";
import MusicPlayer from "./components/MusicPlayer";

function App() {
  const [currentSection, setCurrentSection] = useState("landing");
  const [musicPlaying, setMusicPlaying] = useState(false);

  return (
    <div className="app">
      <FloatingHearts />
      <MusicPlayer 
        musicPlaying={musicPlaying} 
        setMusicPlaying={setMusicPlaying} 
      />
      
      {currentSection === "landing" && (
        <LandingPage 
          onNext={() => setCurrentSection("cards")}
          onMusicToggle={() => setMusicPlaying(!musicPlaying)}
        />
      )}
      
      {currentSection === "cards" && (
        <CardCarousel 
          onNext={() => setCurrentSection("gallery")}
          onBack={() => setCurrentSection("landing")}
        />
      )}
      
      {currentSection === "gallery" && (
        <PhotoGallery 
          onNext={() => setCurrentSection("plans")}
          onBack={() => setCurrentSection("cards")}
        />
      )}
      
      {currentSection === "plans" && (
        <ValPlans 
          onBack={() => setCurrentSection("gallery")}
        />
      )}

      <CountdownTimer />
    </div>
  );
}

export default App;
